<template>
  <ImageSlider :img-urls="imgUrls" />
  <h1 class="my-4 text-lg font-normal tracking-[0.5px] md:text-2xl">{{ cmsExperience.title }}</h1>
  <div class="mb-6 text-base leading-6 tracking-normal text-black2 md:leading-7" v-html="cmsExperience.overviewV2"></div>
  <ExperienceInfoSectionSummary :enable-pc-layout="true" :experience="experience" />
</template>

<script setup lang="ts">
import type { EnExperienceViewModel } from '@/models/enExperience';
import type { WabunkaExperienceViewModel } from '@/models/wabunka/wabunkaExperience';
import { ImageSlider } from '@/wabunka-src/common/components';
import { ExperienceInfoSectionSummary } from '@/wabunka-src/common/features/Featured';
interface Props {
  cmsExperience: EnExperienceViewModel;
  experience: WabunkaExperienceViewModel;
}

const props = defineProps<Props>();
const imgUrls = computed<string[]>(() => {
  // subImages / image は MicroCMS optional フィールド（型は required だが実体は欠落し得る）。
  // 未定義のまま .map / .url にアクセスすると SSR 500 になるためガードする（JCAT-5180）
  return (props.cmsExperience.subImages ?? []).map((subImage) => subImage.image?.url ?? '').filter((url) => url !== '');
});
</script>
